import script from "./HandwritingGame.vue?vue&type=script&setup=true&lang=js"
export * from "./HandwritingGame.vue?vue&type=script&setup=true&lang=js"

import "./HandwritingGame.vue?vue&type=style&index=0&id=0b8ca05c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8ca05c"]])

export default __exports__